import { render, staticRenderFns } from "./BodyFooter.vue?vue&type=template&id=1678e432&"
import script from "./BodyFooter.vue?vue&type=script&lang=js&"
export * from "./BodyFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BodyFooter.vue"
export default component.exports